import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "container",
        "template",
        "amount",
        "receiptTotal",
        "receiptTotalDisplay",
        "allocatedTotal",
        "remaining",
        "submitButton"
    ]

    connect() {
        this.recalculate()
    }

    // ------------------------------------------------------------
    // Recalculate totals
    // ------------------------------------------------------------

    recalculate() {
        const receiptTotal = parseFloat(this.receiptTotalTarget.value || 0)

        let allocated = 0

        this.amountTargets.forEach(input => {
            const value = parseFloat(input.value)
            if (!isNaN(value)) allocated += value
        })

        const remaining = receiptTotal - allocated

        this.receiptTotalDisplayTarget.textContent = receiptTotal.toFixed(2)
        this.allocatedTotalTarget.textContent = allocated.toFixed(2)
        this.remainingTarget.textContent = remaining.toFixed(2)

        this.remainingTarget.classList.toggle("fg-danger", remaining !== 0)
        this.remainingTarget.classList.toggle("fg-success", remaining === 0)

        // 🔥 Only validate — do NOT emit here anymore
        this.valid()
    }

    // ------------------------------------------------------------
    // Form validation
    // ------------------------------------------------------------

    valid() {
        const receiptTotal = parseFloat(this.receiptTotalTarget.value || 0)
        const remaining = parseFloat(this.remainingTarget.textContent || 0)
        const client = this.element.querySelector("[name='receipt[client_id]']")
        const date = this.element.querySelector("[name='receipt[receipt_date]']")

        let valid = true

        console.log(client && client.value)
        console.log(!client || !client.value.trim() ? "no client found" : client.value)
        if (!client || !client.value.trim()) valid = false
        if (!date || !date.value) valid = false

        // ---- Total must be positive ----
        if (isNaN(receiptTotal) || receiptTotal <= 0) valid = false

        // ---- Totals must match ----
        if (Math.abs(remaining) > 0.01) valid = false

        // ---- Must have at least one allocation ----
        if (this.amountTargets.length === 0) valid = false

        // ---- Allocation amounts must be valid ----
        this.amountTargets.forEach(input => {
            const value = parseFloat(input.value)
            if (isNaN(value) || value <= 0) valid = false
        })

        // ---- Check required header fields ----
        // Works without declaring targets for them
        const requiredFields = this.element.querySelectorAll(
            "select[required], input[required]"
        )

        requiredFields.forEach(field => {
            if (!field.value) valid = false
        })

        if (this.hasSubmitButtonTarget) {
            this.submitButtonTarget.disabled = !valid
        } else {
            // 🔥 Emit global form state event
            this.element.dispatchEvent(
                new CustomEvent("form:state", {
                    bubbles: true,
                    detail: { valid }
                })
            )
        }
        
        return valid
    }

    // ------------------------------------------------------------
    // Remove allocation line
    // ------------------------------------------------------------

    removeLine(event) {
        event.preventDefault()

        const line = event.target.closest(".allocation-line")
        if (line) line.remove()

        this.recalculate()
    }

    // ------------------------------------------------------------
    // Add allocation line (from template)
    // ------------------------------------------------------------

    addLine() {
        const index = Date.now()

        const content = this.templateTarget.innerHTML.replace(
            /NEW_RECORD/g,
            index
        )

        this.containerTarget.insertAdjacentHTML("beforeend", content)

        this.recalculate()
    }
}
